<div class="side-bar-container" *ngIf="isVisible">
    <div class="button-bar header">
        <ng-container #headerContainer></ng-container>
    </div>
    <div class="button-bar menu-buttons">
        <button *ngFor="let button of menuButtons" mat-icon-button
            [class.active]="button == active" disableRipple (click)="handleClick(button)"
            [matTooltip]="button.text | translate">
            <mat-icon [svgIcon]="button.iconName"></mat-icon>
        </button>
    </div>
    <div class="button-bar footer">
        <ng-container #footerContainer></ng-container>
    </div>
</div>
